import { FOG_20, OwnUpDefaultErrorNotification } from '@rategravity/own-up-component-library';
import { APRICOT_10, BERRY_10, MOSS_50 } from '@rategravity/own-up-component-library';
import React from 'react';

import { useCalculator } from '../../data/dataProvider';
import { Affordability } from '../../types';
import { AffordabilityDetailTitle, Body, BodyCopy, Container } from './elements';

export const affordabilityColors = {
  Affordable: MOSS_50,
  Stretching: APRICOT_10,
  Aggressive: BERRY_10
};

export const DetailImpl = ({
  affordability,
  downPaymentPercentage,
  dti,
  error,
  children
}: React.PropsWithChildren<{
  affordability: Affordability;
  downPaymentPercentage: number;
  dti: number;
  error?: string;
}>) => {
  const affordabilityColor = !!error ? FOG_20 : affordabilityColors[affordability];

  return (
    <Container backgroundColor={affordabilityColor}>
      {error ? (
        <React.Fragment>
          <OwnUpDefaultErrorNotification $hasIcon={true} title="Error" description={error} />
          {children}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <AffordabilityDetailTitle affordability={affordability} />
          <Body>
            <BodyCopy
              affordability={affordability}
              downPaymentPercentage={downPaymentPercentage}
              dti={dti}
            />
          </Body>
          {children}
        </React.Fragment>
      )}
    </Container>
  );
};

export const SummaryArticle = ({ children }: React.PropsWithChildren<{}>) => {
  const { getResultDTISelector, getAffordability, getDownPaymentPercentage, getError } =
    useCalculator();
  const affordability = getAffordability();
  const downPaymentPercentage = getDownPaymentPercentage();
  const dti = getResultDTISelector();
  const error = getError();

  return (
    <DetailImpl
      affordability={affordability}
      downPaymentPercentage={downPaymentPercentage}
      dti={dti}
      error={error}
    >
      {children}
    </DetailImpl>
  );
};
